import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { catchError, delay, finalize, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { BusyService } from '../services/busy.service';
import { AlertService } from '../services/alert.service';
import { SKIP_GLOBAL_ALERT } from '../tokens/http-context-tokens';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = localStorage.getItem('token') || '';
  const busyService = inject(BusyService);
  const alertService = inject(AlertService);
  const urlsWithLoading = ['auth/signin', '/api/usuarios', '/api/image/upload'];
  const mustShowLoading = urlsWithLoading.some((url) => req.url.includes(url));

  req = req.clone({
    headers: req.headers.append('Bearer', token),
  });

  if (mustShowLoading) {
    busyService.busy();
  }

  return next(req).pipe(
    finalize(() => {
      busyService.idle();
    }),
    catchError((error) => {
      // add context in query for skip global alert
      const skipAlert = req.context.get(SKIP_GLOBAL_ALERT);

      if (!skipAlert) {
        alertService.errorNotification(error);
      }

      if (error instanceof HttpErrorResponse && error.status === 401) {
        authService.logout();
        router.navigate(['/login']);
      }
      return throwError(() => error);
    }),
  );
};
